import { checkExpiryDate, transformExtraPromotion } from 'helpers';
import { magentoService } from 'services';
import useSWR from 'swr';
import { ExtraPromotion } from 'types';

export const useCustomPromotion = () => {
  const { data } = useSWR(
    [`/magento/customdata/custom_promo_text`, 'custom_promo_text'],
    (_url, code) =>
      magentoService.getCustomData(code).then((res) =>
        Object.values((res.data?.data as ExtraPromotion) || {})
          .map((promotion) => transformExtraPromotion(promotion))
          .filter(
            (promotion) =>
              promotion.date &&
              checkExpiryDate(promotion.date.startDate, promotion.date.endDate),
          ),
      ),
    {
      revalidateOnFocus: false,
    },
  );

  return {
    customPromotions: data || [],
  };
};
